<template><span style="display: none" aria-hidden="true"></span></template>

<script>
import { notificationStore } from "@/notificationStore";
import { createOrderSound } from "@/modules/Restaurante/pages/PedidosOnline/orderSound";
import { monitorCatalogOrders } from "../services/catalogoDigitalApi";

const POLL_INTERVAL_MS = 60 * 1000;

export default {
  name: "CatalogoDigitalOrderPoller",
  props: {
    empresaId: { type: Number, required: true },
  },
  data() {
    return {
      cursor: null,
      intervalId: null,
      retryId: null,
      emAndamento: false,
      encerrado: false,
      configuracaoVersao: 0,
      reconsultar: false,
      somAtivo: false,
      somPronto: false,
      somPendente: false,
      somVersao: 0,
      orderSound: null,
    };
  },
  mounted() {
    this.orderSound = createOrderSound();
    window.addEventListener(
      "catalogo-digital:configuracao-alterada",
      this.configuracaoAlterada
    );
    window.addEventListener("catalogo-digital:liberar-som", this.liberarSom);
    window.addEventListener("catalogo-digital:som-alterado", this.somAlterado);
    document.addEventListener("pointerdown", this.desbloquearSom);
    document.addEventListener("keydown", this.desbloquearSom);
    document.addEventListener("visibilitychange", this.consultarAoRetomar);
    this.consultar();
  },
  beforeDestroy() {
    this.encerrado = true;
    this.configuracaoVersao += 1;
    window.removeEventListener(
      "catalogo-digital:configuracao-alterada",
      this.configuracaoAlterada
    );
    window.removeEventListener("catalogo-digital:liberar-som", this.liberarSom);
    window.removeEventListener(
      "catalogo-digital:som-alterado",
      this.somAlterado
    );
    document.removeEventListener("pointerdown", this.desbloquearSom);
    document.removeEventListener("keydown", this.desbloquearSom);
    document.removeEventListener("visibilitychange", this.consultarAoRetomar);
    this.somPendente = false;
    if (this.orderSound) this.orderSound.close();
    this.parar();
  },
  methods: {
    consultarAoRetomar() {
      if (this.encerrado || document.visibilityState !== "visible") return;
      if (this.emAndamento) this.reconsultar = true;
      else return this.consultar();
    },
    async liberarSom() {
      if (this.encerrado || !this.orderSound) return;
      const pronto = await this.orderSound.unlock();
      if (this.encerrado) return;
      this.somPronto = pronto;
      if (this.somAtivo && pronto && this.somPendente) {
        this.somPendente = false;
        this.orderSound.play();
      }
    },
    desbloquearSom() {
      if (this.somAtivo && !this.somPronto) this.liberarSom();
    },
    somAlterado(event) {
      this.somVersao += 1;
      this.atualizarSom(Boolean(event.detail?.som_novos_pedidos));
    },
    atualizarSom(ativo) {
      this.somAtivo = ativo;
      if (!ativo) {
        this.somPendente = false;
        if (this.orderSound) this.orderSound.stop();
      }
    },
    configuracaoAlterada(event) {
      if (event.detail?.ativo && this.intervalId !== null) return;
      this.configuracaoVersao += 1;
      this.parar();
      this.cursor = null;
      if (!event.detail?.ativo) {
        this.reconsultar = false;
        this.atualizarSom(false);
        return;
      }
      if (this.emAndamento) this.reconsultar = true;
      else this.consultar();
    },
    parar() {
      if (this.intervalId !== null) clearInterval(this.intervalId);
      if (this.retryId !== null) clearTimeout(this.retryId);
      this.intervalId = null;
      this.retryId = null;
    },
    async consultar() {
      if (this.encerrado || this.emAndamento) return;
      this.emAndamento = true;
      const versao = this.configuracaoVersao;
      const somVersao = this.somVersao;
      try {
        const resultado = await monitorCatalogOrders(this.cursor);
        if (this.encerrado || versao !== this.configuracaoVersao) return;
        if (!resultado.ativo) {
          this.parar();
          this.cursor = null;
          this.atualizarSom(false);
          return;
        }
        if (somVersao === this.somVersao) {
          this.atualizarSom(Boolean(resultado.som_novos_pedidos));
        }

        if (Number.isFinite(Number(resultado.total_nao_lidas))) {
          notificationStore.total = Number(resultado.total_nao_lidas);
        }
        const primeiraConsulta = this.cursor === null;
        const novos = Number(resultado.novos) || 0;
        this.cursor = resultado.cursor;
        if (novos > 0) {
          this.$root.$emit("catalogo-digital:novos-pedidos", {
            empresaId: this.empresaId,
            quantidade: novos,
          });
          if (
            !primeiraConsulta &&
            this.somAtivo &&
            this.orderSound &&
            !this.orderSound.play()
          ) {
            this.somPronto = false;
            this.somPendente = true;
          }
        }
        if (this.intervalId === null) {
          this.intervalId = setInterval(
            () => this.consultar(),
            POLL_INTERVAL_MS
          );
        }
      } catch (error) {
        if (this.encerrado || versao !== this.configuracaoVersao) return;
        // Falha transitória não avança a linha de base nem cria notificações.
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          this.parar();
          this.atualizarSom(false);
          return;
        }
        if (
          !this.encerrado &&
          this.intervalId === null &&
          this.retryId === null
        ) {
          this.retryId = setTimeout(() => {
            this.retryId = null;
            this.consultar();
          }, POLL_INTERVAL_MS);
        }
      } finally {
        this.emAndamento = false;
        if (!this.encerrado && this.reconsultar) {
          this.reconsultar = false;
          this.consultar();
        }
      }
    },
  },
};
</script>
